import { combineReducers } from 'redux';
import auth from './auth';
import products from './products';
import settings from './settings';
import users from './users';
import navigation from './navigation';
import stripe from './stripe';
import sales from './sales';
import venues from './venues';
import menus from './menus';
import merchantPayout from './merchantPayout';
import { connectRouter } from 'connected-react-router';

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    auth,
    navigation,
    products,
    settings,
    users,
    sales,
    stripe,
    venues,
    menus,
    merchantPayout
});
